import { render, staticRenderFns } from "./ActionCambioEsperaDeParte.vue?vue&type=template&id=2581db86&lang=pug"
import script from "./ActionCambioEsperaDeParte.vue?vue&type=script&lang=js"
export * from "./ActionCambioEsperaDeParte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports